module.exports = __webpack_public_path__ + "static/media/CircularXXWeb-Medium.d74eac43.woff2";